module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Media-14e547e6b4658b97d439659b3e4180db.svg";